
import { envConfig } from "@env/env-config";

/**
 * @description 匿名用户 Rest配置
 * @deprecated
 */
export const AnonymousRestConfig: Array<qpmn.common.rest.IServiceConfig> = [
    {
        service: "anonymousUserRestService",
        funcName: "login",
        config: {
            method: "get",
            appPath: envConfig.apps.base,
            path: "anonymousUser/:anonymousUserId/token/",
            isAuth: false,
            paramDefaults: { anonymousUserId: "@anonymousUserId" }
        }
    }
]